import { TextField as MUITextField, Typography } from "@material-ui/core";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import CloseIcon from "@material-ui/icons/Close";
import MenuOpenIcon from "@material-ui/icons/MenuOpen";
import { Alert } from "@material-ui/lab";
import ContentTitle from "components/common/ContentTitle";
import Steper from "components/common/Steper";
import DataPrivate from "components/ltr-request-document/components/DataPrivate";
import EducationSection from "components/ltr-request-document/components/EducationSection";
import ExpertiseSection from "components/ltr-request-document/components/ExpertiseSection";
import PersonalInfoSection from "components/ltr-request-document/components/PersonalInfoSection";
import SpouseSection from "components/ltr-request-document/components/SpouseSection";
import WorkExperienceSection from "components/ltr-request-document/components/WorkExperienceSection";
import ButtonController from "components/request-document/components/ButtonController";
import {
  StyledTableCell,
  useStyles
} from "components/request-document/components/Commons";
import useSmartSubName from "components/request-document/hooks/useSmartSubName";
import { useFormik } from "formik";
import nationalities from "i18n-nationality";
import {
  REQUEST_DOCUMENT_STEP_LTR,
  RoleId,
  STATUS_PROCESS
} from "libs/configs/constant";
import { LTR_STEP } from "libs/constant/Step";
import useModalLoading from "libs/hooks/useModalLoading";
import {
  defaultChildren,
  defaultDirectInvestmentTable,
  defaultEducationData,
  defaultGovernmentBond,
  defaultJobWorkpermitTable,
  defaultRealEstate,
  defaultSpouse,
  defaultWorkExperience,
  defaultWorkExperienceTable,
  getDefaultRow,
  mapChildren,
  mapDirectInvestmentTable,
  mapEducationData,
  mapGovernmentBond,
  mapJobWorkpermitTable,
  mapRealEstate,
  mapSpouse,
  mapWorkExperience,
  mapWorkExperienceTable,
  personalFieldResolver
} from "libs/utils/form";
import { formatDate } from "libs/utils/format";
import { convertMRZDate } from "libs/utils/mrzUtils";
import { get, pick } from "lodash";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  addPersonal,
  addPersonalSlice,
  selectAddPersonal
} from "redux/modules/addPersonalSlice";
import { canEditForm } from "redux/modules/authSlice";
import { getMasterData, selectMasterData } from "redux/modules/masterSlice";
import { selectPassportState } from "redux/modules/passportSlice";
import { selectPersonalDetail } from "redux/modules/personalSlice";
import { setSmartFormStep } from "redux/modules/uiSlice";
import {
  addSmartForm,
  addSmartFormSlice,
  getSmartForm,
  getSmartFormFieldConfig,
  selectAddSmartForm,
  selectCurrentSmartForm,
  selectCurrentSmartServiceId,
  selectDraftId,
  selectSmartFormFieldConfig
} from "redux/modules/visaForm";
import * as yup from "yup";
const TextField = React.memo(MUITextField);

export default function UserProfile() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const subName = useSmartSubName();
  const { showLoading, hideLoading } = useModalLoading();
  const [isSaveDraft, setSaveDraft] = useState(false);

  const passportState = useSelector(selectPassportState);
  const personalDetail = useSelector(selectPersonalDetail);
  const addPersonalState = useSelector(selectAddPersonal);
  const smartServiceId = useSelector(selectCurrentSmartServiceId);
  const masterData = useSelector(selectMasterData);
  const smartFormFieldConfig = useSelector(selectSmartFormFieldConfig);
  const draftId = useSelector(selectDraftId);
  const smartform = useSelector(selectCurrentSmartForm);
  const addSmartFormState = useSelector(selectAddSmartForm);
  const canEdit = useSelector(canEditForm);
  const assignmentConfig = get(masterData, "assignmentConfig", []);
  const Role = useSelector((e) => {
    return e.user.profile.roleId;
  });

  const nationalityConfig = get(masterData, "nationalityConfig", []);
  const personalId = get(personalDetail, "personalID", "");
  const ocrFirstName = get(passportState, "detail.firstName", "");
  const ocrLastName = get(passportState, "detail.lastName", "");
  const ocrBirthDate = convertMRZDate(
    get(passportState, "detail.birthDate", "")
  );
  const nationalityAlpha3 = get(passportState, "detail.nationality", "");
  const nationalityName = nationalities.getName(nationalityAlpha3, "en");
  const ocrNationalityID = get(
    nationalityConfig.find((v) => v.nationalityName === nationalityName),
    "nationalityID",
    ""
  );
  const ocrExpirationDate = convertMRZDate(
    get(passportState, "detail.expirationDate", "")
  );
  const ocrSex = get(passportState, "detail.sex", "").slice(0, 1).toUpperCase();
  const ocrDocumentNumber = get(passportState, "detail.documentNumber", "");

  //scroll
  const info = useRef(null);
  const income = useRef(null);
  const expertise = useRef(null);
  const company = useRef(null);
  const medical = useRef(null);
  const detailapplicantMenu = useRef(null);
  const BottomButton = useRef(null);
  const [BottomVisible, setBottomVisible] = useState(false);
  const [MenuOpen, setMenuOpen] = useState(false);
  const [hintMenu, setHintMenu] = useState(false);

  const handleOnNext = () => {
    dispatch(setSmartFormStep(LTR_STEP.SHOW_FORM_WORKPERMITSTEP));
    return;
  };

  const personal = pick(get(smartform, "personal", {}), [
    "titleID",
    "personalID",
    "firstname",
    "middleName",
    "lastName",
    "nationalityID",
    "birthDate",
    "email",
    "placeOfBirth",
    "gender",
    "passportNumber",
    "dateofIssue",
    "validuntil",
    "visatypeID",
    "issuedAt",
    "mobile",
    "soi",
    "road",
    "titleOther",
    "maritalID",
    "MaritalOther",
    "addressInHomeCountry",
    "addressInThailand",
    "ProvinceId",
    "SubDistrictId",
    "DistrictId",
    "identificationNumber",
    "accommodationID",
    "houseNumber",
  ]);
  const detailList = [
    "Marittal",
    "PersonalAddressInHome",
    "AddressInThai",
    "SubDistrict",
    "District",
    "Province",
    "Zipcode",
    "PhoneNumber",
    "Email",
    "assignmentId",
    "assignmentId2",
    "assignmentId3",
    "DetailofExpertise",
    "Spouse",
    "Children",
    "EducationOther",
    "Education",
    "ReferencePersonName",
    "sourcesOfincomeID",
    "sourcesOfincomeOther",
    "GovernmentBond",
    "RealEstate",
    "DirectInvestment",
    "PersonalAddressInThai",
    "GovernmentBondTable",
    "PersonalResidenceType",
    "PersonalProvince",
    "PersonalDistrict",
    "PersonalSubDistrict",
    "PersonalZipcode",
    "PersonalOccupation",
    "ContactPersonInThai",
    "ContactRelationship",
    "ContactEmail",
    "ContactMobile",
    "TotalCurrent",
    "TotalCurrentEnd",
    "IncomeTotalCurrent",
    "LastYear",
    "IncomeLastYear",
    "Last2Year",
    "IncomeLast2Year",
    "TotalTHB",
    "TotalUSD",
    "RealEstateTable",
    "TotalAssetsUSD",
    "AssetsDeposit",
    "AssetsDepositValue",
    "AssetsPrivateCommercial",
    "AssetsPrivateCommercialValue",
    "AssetsCloselyStocks",
    "AssetsCloselyStocksValue",
    "AssetsPubliclyTraded",
    "AssetsPubliclyTradedValue",
    "AssetsGoldAccount",
    "AssetsGoldAccountValue",
    "AssetsOther",
    "AssetsOtherValue",
    "HealthInsurance",
    "Validity",
    "ValidityDateIssue",
    "ValidityDateExpiry",
    "SubmitLater",
    "SocialSecurity",
    "SocialSecurityDate",
    "DepositOfNoless",
    "WorkExperienceTable",
    "IncomeNolessWFTP",
    "NolessCurrentYearIncome",
    "NolessCurrentYearIncomeEnd",
    "NolessIncomeCurrentYearUSD",
    "NolessLastYear",
    "NolessIncomeLastYearUSD",
    "NolessLast2Year",
    "NolessIncomeLast2YearUSD",
    "NolessWFTPsourcesOfincomeID",
    "NolessWFTPsourcesOfincomeOther",
    "IncomeMorethanWFTP",
    "MorethanCurrentYearIncome",
    "MorethanCurrentYearIncomeEnd",
    "MorethanIncomeCurrentYearUSD",
    "MorethanLastYear",
    "MorethanIncomeLastYearUSD",
    "MorethanLast2Year",
    "MorethanIncomeLast2YearUSD",
    "MorethanWFTPsourcesOfincomeID",
    "MorethanWFTPsourcesOfincomeOther",
    "followinvestmentsID",
    "typeOfIntellectualpropertyID",
    "typeOfIntellectualpropertyOther",
    "NameInvention",
    "CertificateNumber",
    "CountryOfregistration",
    "DateRegistration",
    "ObtainingSeriesA",
    "PersonalCompanyName",
    "PersonalCompanyAddress",
    "PersonalProductServices",
    "PersonalFundingAmount",
    "JobPositionWorkOverseas",

    "JobDescriptionWorkOverseas",
    "ContractTermTypeWorkOverseas",
    "ContractMonthsWorkOverseas",
    "ContractYearWorkOverseas",
    "ContractOtherWorkOverseas",
    "WorkOverseasCompanyName",
    "WorkOverseasRegistrationNumber",
    "WorkOverseasCompanyAddress",
    "WorkOverseasCompanyEmail",
    "WorkOverseasOfficePhoneNumber",
    "WorkOverseasProductsServices",
    "typeOfbusinessindustryID",
    "PublicCompany",
    "ListedCompany",
    "StockSymbol",
    "NameStock",
    "PrivateCompany",
    "PrivateCompanyLastYear",
    "PrivateCompanyTotalLastYear",
    "PrivateCompanyLast2Year",
    "PrivateCompanyTotalLast2Year",
    "PrivateCompanyLast3Year",
    "PrivateCompanyTotalLast3Year",
    "GrandTotal",
    "JobPositionWorkOverseas",
    "DirectInvestmentTable",
    "scienceAndtechnologyID",
    "scienceAndtechnologySubID",
    "managementID",
    "managementSubID",
    "DetailsOfExpertise",
    "ExpertiseIsObtained",
    "JobPositionWorkTH",
    "JobDescriptionWorkTH",
    "ContractTermTypeWorkTH",
    "ContractMonthsWorkTH",
    "ContractYearWorkTH",
    "ContractPeriodFromWorkTH",
    "ContractPeriodToWorkTH",
    "ContractOtherWorkTH",
    "CompanyAverIncomemonth",
    "CompanysSalary",
    "CompanyIncomeOther",
    "OrganizationName",
    "OrganizationAddress",
    "OrganizationPhoneNumber",
    "typeOforganizationID",
    "OrganizationReferenceName",
    "OrganizationReferencePosition",
    "OrganizationEmailAddress",
    "OrganizationMobileNumber",
    "OrganizationDetailsActivities",
    "typeOfindustriesID",
    "ExpertiseIsObtained",
  ];
  const detail = get(smartform, "detail", [])
    .filter((field) => detailList.includes(field.smartName))
    .reduce((p, c) => ({ ...p, [c.smartName]: c }), {});

  useEffect(() => {
    dispatch(
      getMasterData({
        nationalityConfig: true,
        AssignmentConfig: true,
        EducationConfig: true,
        CountryConfig: true,
        titleConfig: true,
        sourcesOfincomeConfig: true,
        accommodationConfig: true,
        typeOfIntellectualpropertyConfig: true,
        JobPositionConfig: true,
        typeOfbusinessindustryConfig: true,
        scienceAndtechnologyConfig: true,
        managementConfig: true,
        typeOforganizationConfig: true,
        typeOfindustriesConfig: true,
      })
    );
    return () => {
      dispatch(addPersonalSlice.actions.clearAsyncState());
    };
  }, [dispatch]);

  useEffect(() => {
    if (smartServiceId) {
      dispatch(
        getSmartFormFieldConfig({
          smartserviceId: smartServiceId,
          smartserviceGroupID: "LTR",
        })
      );
      dispatch(
        getSmartForm({
          smartserviceId: smartServiceId,
          draftId,
          personalId,
          smartserviceGroupID: "LTR",
        })
      );
    }
  }, [dispatch, draftId, personalDetail, personalId, smartServiceId]);

  useEffect(() => {
    if (!addPersonalState.isLoading) {
      if (addPersonalState.isSuccess) {
        dispatch(addPersonalSlice.actions.clearAsyncState());
      } else if (addPersonalState.isFailure) {
        hideLoading();
        alert(addPersonalState.error?.message);
        dispatch(addPersonalSlice.actions.clearAsyncState());
      }
    }
  }, [addPersonalState, dispatch, hideLoading]);

  useEffect(() => {
    if (!addSmartFormState.isLoading) {
      if (addSmartFormState.isSuccess) {
        hideLoading();
        dispatch(addSmartFormSlice.actions.clearAsyncState());
        if (!isSaveDraft) {
          dispatch(setSmartFormStep(LTR_STEP.SHOW_FORM_STEP));
        }
      } else if (addSmartFormState.isFailure) {
        hideLoading();
        alert(addSmartFormState.error?.message);
        dispatch(addSmartFormSlice.actions.clearAsyncState());
      }
    }
  }, [addSmartFormState, dispatch, hideLoading, isSaveDraft]);

  const validationSchema = yup.object({});

  const callAPISubmit = async (values) => {
    showLoading();

    const defaultType = get(smartFormFieldConfig, "data.defaultType", []);
    const documentFields = Object.keys(values.document);
    const getFieldListConfig = defaultType.filter((field) =>
      documentFields.includes(field.smartName)
    );

    const getValue = (field) => {
      switch (field.smartName) {
        case "Spouse": {
          const spouseName = get(values, `document.${field.smartName}`, []);
          const value = spouseName.filter((v) => !!v.SpouseName);
          return value || null;
        }
        case "Children": {
          const childrenName = get(values, `document.${field.smartName}`, []);
          const value = childrenName.filter((v) => !!v.ChildrenName);
          return value || null;
        }
        case "Education": {
          const educationId = get(values, `document.${field.smartName}`, {
            EducationConfigID: null,
            data: [],
          });
          const data = educationId.data.filter((v) => !!v.educationName);

          return {
            EducationConfigID: educationId.EducationConfigID,
            data: data.length ? data : null,
          };
        }
        case "WorkExperienceTable": {
          const workExperience = get(values, `document.${field.smartName}`, []);
          console.log(workExperience);
          const value = workExperience
            .filter((v) => !!v.WorkOrganization)
            .map((x) => {
              return {
                workId: x.workId,
                fileID: x.fileID,
                PreiodFrom: x.PreiodFrom === "" ? null : x.PreiodFrom,
                PreiodTo: x.PreiodTo === "" ? null : x.PreiodTo,
                WorkOrganization:
                  x.WorkOrganization === "" ? null : x.WorkOrganization,
                countryId: x.countryId === "" ? null : x.countryId,
                WorkCity: x.WorkCity === "" ? null : x.WorkCity,
                WorkResponsibility: x.WorkResponsibility,
                Status: x.Status,
              };
            });
          console.log(value);
          return value || null;
        }
        case "GovernmentBondTable": {
          const BondName = get(values, `document.${field.smartName}`, []);
          const value = BondName.filter((v) => !!v.BondName).map((x) => {
            return {
              GovernmentBondID: x.GovernmentBondID,
              GovernmentBond: x.GovernmentBond,
              BondName: x.BondName,
              PurchasingAmountTHB:
                x.PurchasingAmountTHB === "" ? 0 : x.PurchasingAmountTHB,
              IssueDate: x.IssueDate === "" ? null : x.IssueDate,
              MaturityDate: x.MaturityDate === "" ? null : x.MaturityDate,
              AgeYear: x.AgeYear,
              Status: x.Status,
            };
          });

          return value || null;
        }
        case "RealEstateTable": {
          const PropertyName = get(values, `document.${field.smartName}`, []);
          const value = PropertyName.filter((v) => !!v.PropertyName).map(
            (x) => {
              return {
                RealEstateID: x.RealEstateID,
                RealEstate: x.RealEstate,
                PropertyName: x.PropertyName,
                Address: x.Address,
                DateOwnership: x.DateOwnership === "" ? null : x.DateOwnership,
                AcquisitionCost:
                  x.AcquisitionCost === "" ? 0 : x.AcquisitionCost,
                Status: x.Status,
              };
            }
          );

          return value || null;
        }
        default:
          return get(values, `document.${field.smartName}`, null);
      }
    };

    const getSmartId = (field) =>
      get(detail, `${field.smartName}.smartId`, null);

    const prepareData = {
      draftId: draftId || null,
      smartserviceId: smartServiceId,
      personalId: personalId,
      survey: null, // get(smartform, "survey", null), // TODO wait for support case edit
      visaissuance: null, // get(smartform, "visaissuance", null), // TODO wait for support case edit
      detail: [
        ...getFieldListConfig.map((field) => ({
          smartName: field.smartName,
          smartId: getSmartId(field),
          partfromId: field.partfromId,
          configsmartId: field.configsmartId,
          linkTable: field.linkTable,
          value: getValue(field),
        })),
      ],
    };

    await dispatch(
      addPersonal({
        ...personalFieldResolver(values.personal),
        visatypeID: null,
      })
    );
    await dispatch(
      addSmartForm({
        data: prepareData,
      })
    );
  };

  const HasAddressInThai = !!get(detail, "AddressInThai.value", "");
  const isDraftDocument = smartform?.statausID === STATUS_PROCESS.Draft;

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      personal: {
        titleID: get(personal, "titleID", ""),
        personalID: get(personal, "personalID", ""),
        fistName: ocrFirstName || get(personal, "firstname", ""),
        middleName: get(personal, "middleName", "") || "",
        lastName: ocrLastName || get(personal, "lastName", ""),
        nationalityID:
          ocrNationalityID || get(personal, "nationalityID", "") || "",
        birthDate: formatDate(
          ocrBirthDate || get(personal, "birthDate", "") || ""
        ),
        email: get(personal, "email", "") || "",
        mobile: get(personal, "mobile", "") || "",
        placeOfBirth: get(personal, "placeOfBirth", "") || "",
        gender: ocrSex || get(personal, "gender", "M") || "M",
        passportNumber:
          ocrDocumentNumber || get(personal, "passportNumber", "") || "",
        issuedAt: get(personal, "issuedAt", ""),
        soi: get(personal, "soi", ""),
        road: get(personal, "road", ""),
        dateofIssue: formatDate(get(personal, "dateofIssue", "") || ""),
        validuntil: formatDate(
          ocrExpirationDate || get(personal, "validuntil", "") || ""
        ),
        visatypeID: null,
        titleOther: get(personal, "titleOther", ""),
        MaritalID: get(personal, "maritalID", "S"),
        MaritalOther: get(personal, "MaritalOther", ""),
        addressInHomeCountry: get(personal, "addressInHomeCountry", ""),
        addressInThailand: get(personal, "addressInThailand", ""),
        // ProvinceId: get(personal, "ProvinceId", ""),
        // SubDistrictId: get(personal, "SubDistrictId", ""),
        // DistrictId: get(personal, "DistrictId", ""),
        identificationNumber: get(personal, "identificationNumber", ""),
        accommodationID: get(personal, "accommodationID", ""),
        houseNumber: get(personal, "houseNumber", ""),
      },
      document: {
        Marittal: get(detail, "Marittal.value", "S"),
        PersonalAddressInHome: get(detail, "PersonalAddressInHome.value", ""),
        HasAddressInThai,
        AddressInThai: get(detail, "AddressInThai.value", ""),
        SubDistrict: get(detail, "SubDistrict.value", ""),
        District: get(detail, "District.value", ""),
        Province: get(detail, "Province.value", ""),
        Zipcode: get(detail, "Zipcode.value", ""),
        PhoneNumber: get(detail, "PhoneNumber.value", ""),
        Email: get(detail, "Email.value", ""),
        assignmentId: get(detail, "assignmentId.value", ""),
        assignmentId2: get(detail, "assignmentId2.value", ""),
        assignmentId3: get(detail, "assignmentId.3value", ""),
        DetailofExpertise: get(detail, "DetailofExpertise.value", ""),
        ReferencePersonName: get(detail, "ReferencePersonName.value", ""),
        sourcesOfincomeID: get(detail, "sourcesOfincomeID.value", ""),
        sourcesOfincomeOther: get(detail, "sourcesOfincomeOther.value", ""),
        GovernmentBond: get(detail, "GovernmentBond.value", ""),
        RealEstate: get(detail, "RealEstate.value", ""),
        DirectInvestment: get(detail, "DirectInvestment.value", ""),
        PersonalAddressInThai: get(detail, "PersonalAddressInThai.value", ""),
        PersonalResidenceType: get(detail, "PersonalResidenceType.value", ""),
        PersonalProvince: get(detail, "PersonalProvince.value", ""),
        PersonalDistrict: get(detail, "PersonalDistrict.value", ""),
        PersonalSubDistrict: get(detail, "PersonalSubDistrict.value", ""),
        PersonalZipcode: get(detail, "PersonalZipcode.value", ""),
        PersonalOccupation: get(detail, "PersonalOccupation.value", ""),
        ContactPersonInThai: get(detail, "ContactPersonInThai.value", ""),
        ContactRelationship: get(detail, "ContactRelationship.value", ""),
        ContactEmail: get(detail, "ContactEmail.value", ""),
        ContactMobile: get(detail, "ContactMobile.value", ""),
        TotalCurrent: get(detail, "TotalCurrent.value", ""),
        TotalCurrentEnd: get(detail, "TotalCurrentEnd.value", ""),
        IncomeTotalCurrent: get(detail, "IncomeTotalCurrent.value", ""),
        LastYear: get(detail, "LastYear.value", ""),
        IncomeLastYear: get(detail, "IncomeLastYear.value", ""),
        Last2Year: get(detail, "Last2Year.value", ""),
        IncomeLast2Year: get(detail, "IncomeLast2Year.value", ""),
        TotalTHB: get(detail, "TotalTHB.value", ""),
        TotalUSD: get(detail, "TotalUSD.value", ""),
        TotalAssetsUSD: get(detail, "TotalAssetsUSD.value", ""),
        AssetsDeposit: get(detail, "AssetsDeposit.value", ""),
        AssetsDepositValue: get(detail, "AssetsDepositValue.value", ""),
        AssetsPrivateCommercial: get(
          detail,
          "AssetsPrivateCommercial.value",
          ""
        ),
        AssetsPrivateCommercialValue: get(
          detail,
          "AssetsPrivateCommercialValue.value",
          ""
        ),
        AssetsCloselyStocks: get(detail, "AssetsCloselyStocks.value", ""),
        AssetsCloselyStocksValue: get(
          detail,
          "AssetsCloselyStocksValue.value",
          ""
        ),
        AssetsPubliclyTraded: get(detail, "AssetsPubliclyTraded.value", ""),
        AssetsPubliclyTradedValue: get(
          detail,
          "AssetsPubliclyTradedValue.value",
          ""
        ),
        AssetsGoldAccount: get(detail, "AssetsGoldAccount.value", ""),
        AssetsGoldAccountValue: get(detail, "AssetsGoldAccountValue.value", ""),
        AssetsOther: get(detail, "AssetsOther.value", ""),
        AssetsOtherValue: get(detail, "AssetsOtherValue.value", ""),
        HealthInsurance: get(detail, "HealthInsurance.value", ""),
        Validity: get(detail, "Validity.value", ""),
        ValidityDateIssue: get(detail, "ValidityDateIssue.value", ""),
        ValidityDateExpiry: get(detail, "ValidityDateExpiry.value", ""),
        SubmitLater: get(detail, "SubmitLater.value", ""),
        SocialSecurity: get(detail, "SocialSecurity.value", ""),
        SocialSecurityDate: get(detail, "SocialSecurityDate.value", ""),
        DepositOfNoless: get(detail, "DepositOfNoless.value", ""),
        IncomeNolessWFTP: get(detail, "IncomeNolessWFTP.value", ""),
        NolessCurrentYearIncome: get(
          detail,
          "NolessCurrentYearIncome.value",
          ""
        ),
        NolessCurrentYearIncomeEnd: get(
          detail,
          "NolessCurrentYearIncomeEnd.value",
          ""
        ),
        NolessIncomeCurrentYearUSD: get(
          detail,
          "NolessIncomeCurrentYearUSD.value",
          ""
        ),
        NolessLastYear: get(detail, "NolessLastYear.value", ""),
        NolessIncomeLastYearUSD: get(
          detail,
          "NolessIncomeLastYearUSD.value",
          ""
        ),
        NolessLast2Year: get(detail, "NolessLast2Year.value", ""),
        NolessIncomeLast2YearUSD: get(
          detail,
          "NolessIncomeLast2YearUSD.value",
          ""
        ),
        NolessWFTPsourcesOfincomeID: get(
          detail,
          "NolessWFTPsourcesOfincomeID.value",
          ""
        ),
        NolessWFTPsourcesOfincomeOther: get(
          detail,
          "NolessWFTPsourcesOfincomeOther.value",
          ""
        ),
        IncomeMorethanWFTP: get(detail, "IncomeMorethanWFTP.value", ""),
        MorethanCurrentYearIncome: get(
          detail,
          "MorethanCurrentYearIncome.value",
          ""
        ),
        MorethanCurrentYearIncomeEnd: get(
          detail,
          "MorethanCurrentYearIncomeEnd.value",
          ""
        ),
        MorethanIncomeCurrentYearUSD: get(
          detail,
          "MorethanIncomeCurrentYearUSD.value",
          ""
        ),
        MorethanLastYear: get(detail, "MorethanLastYear.value", ""),
        MorethanIncomeLastYearUSD: get(
          detail,
          "MorethanIncomeLastYearUSD.value",
          ""
        ),
        MorethanLast2Year: get(detail, "MorethanLast2Year.value", ""),
        MorethanIncomeLast2YearUSD: get(
          detail,
          "MorethanIncomeLast2YearUSD.value",
          ""
        ),
        MorethanWFTPsourcesOfincomeID: get(
          detail,
          "MorethanWFTPsourcesOfincomeID.value",
          ""
        ),
        MorethanWFTPsourcesOfincomeOther: get(
          detail,
          "MorethanWFTPsourcesOfincomeOther.value",
          ""
        ),
        followinvestmentsID: get(detail, "followinvestmentsID.value", ""),
        typeOfIntellectualpropertyID: get(
          detail,
          "typeOfIntellectualpropertyID.value",
          ""
        ),
        typeOfIntellectualpropertyOther: get(
          detail,
          "typeOfIntellectualpropertyOther.value",
          ""
        ),
        NameInvention: get(detail, "NameInvention.value", ""),
        CertificateNumber: get(
          detail,
          "NoCertificateNumberlessCurrentYearIncome.value",
          ""
        ),
        CountryOfregistration: get(detail, "CountryOfregistration.value", ""),
        DateRegistration: get(detail, "DateRegistration.value", ""),
        ObtainingSeriesA: get(detail, "ObtainingSeriesA.value", ""),
        PersonalCompanyName: get(detail, "PersonalCompanyName.value", ""),
        PersonalCompanyAddress: get(detail, "PersonalCompanyAddress.value", ""),
        PersonalProductServices: get(
          detail,
          "PersonalProductServices.value",
          ""
        ),
        PersonalFundingAmount: get(detail, "PersonalFundingAmount.value", ""),
        // JobPositionWorkOverseas: get(
        //   detail,
        //   "JobPositionWorkOverseas.value",
        //   ""
        // ),
        JobDescriptionWorkOverseas: get(
          detail,
          "JobDescriptionWorkOverseas.value",
          ""
        ),
        ContractTermTypeWorkOverseas: get(
          detail,
          "ContractTermTypeWorkOverseas.value",
          ""
        ),
        ContractMonthsWorkOverseas: get(
          detail,
          "ContractMonthsWorkOverseas.value",
          ""
        ),
        ContractYearWorkOverseas: get(
          detail,
          "ContractYearWorkOverseas.value",
          ""
        ),
        ContractOtherWorkOverseas: get(
          detail,
          "ContractOtherWorkOverseas.value",
          ""
        ),
        WorkOverseasCompanyName: get(
          detail,
          "WorkOverseasCompanyName.value",
          ""
        ),
        WorkOverseasRegistrationNumber: get(
          detail,
          "WorkOverseasRegistrationNumber.value",
          ""
        ),
        WorkOverseasCompanyAddress: get(
          detail,
          "WorkOverseasCompanyAddress.value",
          ""
        ),
        WorkOverseasCompanyEmail: get(
          detail,
          "WorkOverseasCompanyEmail.value",
          ""
        ),
        WorkOverseasOfficePhoneNumber: get(
          detail,
          "WorkOverseasOfficePhoneNumber.value",
          ""
        ),
        WorkOverseasProductsServices: get(
          detail,
          "WorkOverseasProductsServices.value",
          ""
        ),
        typeOfbusinessindustryID: get(
          detail,
          "typeOfbusinessindustryID.value",
          ""
        ),
        PublicCompany: get(detail, "PublicCompany.value", ""),
        ListedCompany: get(detail, "ListedCompany.value", ""),
        StockSymbol: get(detail, "StockSymbol.value", ""),
        NameStock: get(detail, "NameStock.value", ""),
        PrivateCompany: get(detail, "PrivateCompany.value", ""),
        PrivateCompanyLastYear: get(detail, "PrivateCompanyLastYear.value", ""),
        scienceAndtechnologyID: get(detail, "scienceAndtechnologyID.value", ""),
        scienceAndtechnologySubID: get(
          detail,
          "scienceAndtechnologySubID.value",
          ""
        ),
        managementID: get(detail, "managementID.value", ""),
        managementSubID: get(detail, "managementSubID.value", ""),
        DetailsOfExpertise: get(detail, "DetailsOfExpertise.value", ""),
        ExpertiseIsObtained: get(detail, "ExpertiseIsObtained.value", ""),
        // JobPositionWorkTH: get(detail, "JobPositionWorkTH.value", ""),
        JobDescriptionWorkTH: get(detail, "JobDescriptionWorkTH.value", ""),
        ContractTermTypeWorkTH: get(detail, "ContractTermTypeWorkTH.value", ""),
        ContractMonthsWorkTH: get(detail, "ContractMonthsWorkTH.value", ""),
        ContractYearWorkTH: get(detail, "ContractYearWorkTH.value", ""),
        ContractPeriodFromWorkTH: get(
          detail,
          "ContractPeriodFromWorkTH.value",
          ""
        ),
        ContractPeriodToWorkTH: get(detail, "ContractPeriodToWorkTH.value", ""),
        ContractOtherWorkTH: get(detail, "ContractOtherWorkTH.value", ""),
        CompanyAverIncomemonth: get(detail, "CompanyAverIncomemonth.value", ""),
        CompanysSalary: get(detail, "CompanysSalary.value", ""),
        CompanyIncomeOther: get(detail, "CompanyIncomeOther.value", ""),
        OrganizationName: get(detail, "OrganizationName.value", ""),
        OrganizationAddress: get(detail, "OrganizationAddress.value", ""),
        OrganizationPhoneNumber: get(
          detail,
          "OrganizationPhoneNumber.value",
          ""
        ),
        typeOforganizationID: get(detail, "typeOforganizationID.value", ""),
        OrganizationReferenceName: get(
          detail,
          "OrganizationReferenceName.value",
          ""
        ),
        OrganizationReferencePosition: get(
          detail,
          "OrganizationReferencePosition.value",
          ""
        ),
        OrganizationEmailAddress: get(
          detail,
          "OrganizationEmailAddress.value",
          ""
        ),
        OrganizationMobileNumber: get(
          detail,
          "OrganizationMobileNumber.value",
          ""
        ),
        OrganizationDetailsActivities: get(
          detail,
          "OrganizationDetailsActivities.value",
          ""
        ),
        typeOfindustriesID: get(detail, "typeOfindustriesID.value", ""),
        PrivateCompanyTotalLastYear: get(
          detail,
          "PrivateCompanyTotalLastYear.value",
          ""
        ),
        PrivateCompanyLast2Year: get(
          detail,
          "PrivateCompanyLast2Year.value",
          ""
        ),
        PrivateCompanyTotalLast2Year: get(
          detail,
          "PrivateCompanyTotalLast2Year.value",
          ""
        ),
        PrivateCompanyLast3Year: get(
          detail,
          "PrivateCompanyLast3Year.value",
          ""
        ),
        PrivateCompanyTotalLast3Year: get(
          detail,
          "PrivateCompanyTotalLast3Year.value",
          ""
        ),
        GrandTotal: get(detail, "GrandTotal.value", ""),
        Spouse: getDefaultRow(detail, "Spouse.value", defaultSpouse).map(
          mapSpouse
        ),
        GovernmentBondTable: getDefaultRow(
          detail,
          "GovernmentBondTable.value",
          defaultGovernmentBond
        ).map(mapGovernmentBond),
        WorkExperienceTable: getDefaultRow(
          detail,
          "WorkExperienceTable.value",
          defaultWorkExperienceTable
        ).map(mapWorkExperienceTable),
        DirectInvestmentTable: getDefaultRow(
          detail,
          "DirectInvestmentTable.value",
          defaultDirectInvestmentTable
        ).map(mapDirectInvestmentTable),
        RealEstateTable: getDefaultRow(
          detail,
          "RealEstateTable.value",
          defaultRealEstate
        ).map(mapRealEstate),
        Children: getDefaultRow(detail, "Children.value", defaultChildren).map(
          mapChildren
        ),
        JobPositionWorkTH: getDefaultRow(
          detail,
          "JobPositionWorkTH.value",
          defaultJobWorkpermitTable
        ).map(mapJobWorkpermitTable),
        EducationOther: get(detail, "EducationOther.value", ""),
        Education: {
          EducationConfigID: null,
          data: getDefaultRow(
            detail,
            "Education.value.data",
            defaultEducationData
          ).map(mapEducationData),
        },
      },
    },
    validationSchema: isDraftDocument ? validationSchema : yup.object({}),
    onSubmit: async (values) => {
      if (!canEdit) {
        dispatch(setSmartFormStep(LTR_STEP.SHOW_FORM_STEP));
        return;
      }
      setSaveDraft(false);
      callAPISubmit(values);
    },
  });

  // Disabled all field if status != draft
  if (!isDraftDocument && Role !== RoleId.Admin) {
    formik.handleBlur = () => { };
    formik.handleChange = () => { };
    formik.setFieldValue = () => { };
  }

  //Scrooling
  const onMenuClick = (params) => {
    switch (params) {
      case "info":
        return info?.current.scrollIntoView({ behavior: "smooth" });

      case "expertise":
        return expertise?.current.scrollIntoView({ behavior: "smooth" });
      case "medical":
        return medical?.current.scrollIntoView({
          behavior: "smooth",
        });
      case "company":
        return company?.current.scrollIntoView({
          behavior: "smooth",
        });
      default:
        break;
    }
    // if (params === "info") {
    //   info?.current.scrollIntoView({ behavior: "smooth" });
    //   console.log(params);
    // }
  };

  useEffect(() => {
    window.addEventListener("scroll", () => {
      const maxScroll = document.body.scrollHeight - window.innerHeight;
      if (window.scrollY > 400 && window.scrollY < maxScroll - 100) {
        setBottomVisible(true);
      } else {
        setBottomVisible(false);
      }
    });

    // }
  }, []);

  return (
    <div className={classes.root}>
      {!MenuOpen ? (
        <>
          <div
            style={{
              position: "fixed",
              top: "30%",
              right: 0,
              zIndex: "1999",
              borderRadius: "0.25rem",
              borderWidth: "1px",
              padding: "10px",
              backgroundColor: "#97BAD0",
              boxShadow: "rgba(149, 157, 165, 0.2) 0px 8px 24px",
            }}
          >
            <MenuOpenIcon color="white" onClick={() => setMenuOpen(true)} />
            {!hintMenu ? (
              <div
                style={{
                  position: "absolute",
                  top: "30%",
                  left: "-50%",
                  color: "#fff",
                  minWidth: "200px",
                  background: "#2DCE98",
                  padding: "10px 10px",
                  borderRadius: "0.25rem",
                  width: "100%",
                  transform: "translateX(-100%) translateY(-50%)",
                  zIndex: "1999",
                }}
                onClick={() => setHintMenu(true)}
              >
                <Typography>This Section Menu</Typography>
              </div>
            ) : null}
          </div>
        </>
      ) : (
        <div
          style={{
            position: "fixed",
            top: "30%",
            right: 0,
            zIndex: "1999",
            borderRadius: "0.25rem",
            borderWidth: "1px",
            padding: "10px",
            backgroundColor: "#F7FAFC",
            boxShadow: "rgba(149, 157, 165, 0.2) 0px 8px 24px",
            maxWidth: "600px",
            marginRight: "20px",
          }}
        >
          <CloseIcon
            onClick={() => setMenuOpen(false)}
            style={{ float: "right" }}
          />
          <ContentTitle title="Section" />
          <Typography
            onClick={() => onMenuClick("info")}
            paragraph
            component="span"
            color="primary"
            variant="body1"
          >
            ● Personal Information
          </Typography>
          <br />
          <Typography
            onClick={() => onMenuClick("expertise")}
            paragraph
            component="span"
            color="primary"
            variant="body1"
          >
            ● Expertise Information
          </Typography>
          <br />

          <Typography
            onClick={() => onMenuClick("company")}
            paragraph
            component="span"
            color="primary"
            variant="body1"
          >
            ● Data of private institution, government or state-owned agency in
            Thailand
          </Typography>
          <br />
        </div>
      )}
      <ContentTitle
        title="Application Form"
        subTitle={`APPLICATION FOR QUALIFICATION ENDORSEMENT FOR Long Term Resident Visa (Ltr)
        “High-Skilled Professional`}
      />
      {smartform.draftRemark && <Alert severity="error" style={{ marginTop: 18, marginBottom: 18 }}>{smartform.draftRemark}</Alert>}
      <Steper currentStep={1} isLTR stepInfo={REQUEST_DOCUMENT_STEP_LTR} />
      {/* <Steper currentStep={1} stepInfo={REQUEST_DOCUMENT_STEP} /> */}
      <form onSubmit={formik.handleSubmit} disabled>
        <TableContainer
          style={{ marginTop: 35, borderRadius: 4, overflowX: "unset" }}
        >
          <info ref={info}>
            <Table className={classes.table}>
              <TableHead>
                <TableRow>
                  <StyledTableCell colSpan={7}>
                    <Typography variant="h6" className={classes.tableTitle}>
                      Personal Information
                    </Typography>
                  </StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <PersonalInfoSection formik={formik} />
                <SpouseSection
                  defaultChildren={mapChildren(defaultChildren)}
                  formik={formik}
                />
                <EducationSection
                  defaultEducationData={mapEducationData(defaultEducationData)}
                  formik={formik}
                />

                <WorkExperienceSection
                  defaultWorkExperience={mapWorkExperience(
                    defaultWorkExperience
                  )}
                  formik={formik}
                />
              </TableBody>
            </Table>
          </info>
          {/* Part Expertise Information  */}
          <expertises ref={expertise}>
            <Table className={classes.table} style={{ marginTop: "10px" }}>
              <TableHead>
                <TableRow>
                  <StyledTableCell colSpan={7}>
                    <Typography variant="h6" className={classes.tableTitle}>
                      Expertise Information
                    </Typography>
                  </StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <ExpertiseSection formik={formik} />
              </TableBody>
            </Table>
          </expertises>

          {/* Part Investment  */}
          <companyinfo ref={company}>
            <Table className={classes.table} style={{ marginTop: "10px" }}>
              <TableHead>
                <TableRow>
                  <StyledTableCell colSpan={7}>
                    <Typography variant="h6" className={classes.tableTitle}>
                      Data of private institution, government or state-owned
                      agency in Thailand
                    </Typography>
                  </StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <DataPrivate formik={formik} />
              </TableBody>
            </Table>
          </companyinfo>
        </TableContainer>

        {BottomVisible ? (
          <div
            ref={{ BottomButton }}
            style={{
              position: "fixed",
              left: 0,
              bottom: 0,
              width: "100%",
              backgroundColor: "#F7FAFC",
              borderTopRightRadius: "25px",
              borderTopLeftRadius: "25px",
              color: "white",
              textAlign: "center",
              padding: "10px",
              zIndex: "100",
            }}
          >
            <ButtonController
              onClickSaveDraft={async () => {
                await setSaveDraft(true);
                await callAPISubmit(formik.values);

                await dispatch(
                  getSmartForm({
                    smartserviceId: smartServiceId,
                    draftId,
                    personalId,
                    smartserviceGroupID: "LTR",
                  })
                );
              }}
              onClickNext={async () => {
                await formik.handleSubmit();

                await dispatch(
                  getSmartForm({
                    smartserviceId: smartServiceId,
                    draftId,
                    personalId,
                    smartserviceGroupID: "LTR",
                  })
                );
                await handleOnNext();
              }}
              onClickBack={() =>
                dispatch(setSmartFormStep(LTR_STEP.UPLOAD_PASSPORT))
              }
              isLTR
            />
          </div>
        ) : (
          <ButtonController
            onClickSaveDraft={async () => {
              await setSaveDraft(true);
              await callAPISubmit(formik.values);

              await dispatch(
                getSmartForm({
                  smartserviceId: smartServiceId,
                  draftId,
                  personalId,
                  smartserviceGroupID: "LTR",
                })
              );
            }}
            onClickNext={async () => {
              await formik.handleSubmit();

              await dispatch(
                getSmartForm({
                  smartserviceId: smartServiceId,
                  draftId,
                  personalId,
                  smartserviceGroupID: "LTR",
                })
              );
              await handleOnNext();
            }}
            onClickBack={() =>
              dispatch(setSmartFormStep(LTR_STEP.UPLOAD_PASSPORT))
            }
            isLTR
          />
        )}
      </form>
    </div>
  );
}
